namespace advisorop.components.meetinghub {

    export class MeetingCrudController {
        meeting: domains.IMeeting;
        meetingDate: Date;
        onScheduleMeetingLater: any;
        onCreateMeeting: any;
        onUpdateMeeting: any;
        onCancel: any;
        isAdvisor: boolean;
        availableMeetingTimes: Array<domains.IMeetingAvailabilityDuration>;

        constructor(private meetingHubService: services.MeetingHubService, private advisorService: services.AdvisorService) {
        }

        scheduleMeetingLater(): void {
            this.onScheduleMeetingLater();
        };

        createMeeting(): void {
            this.onCreateMeeting();
        };

        updateMeeting(): void {
            this.onUpdateMeeting();
        }

        cancel(): void {
            this.onCancel();
        };

        getAvailableMeetingTimes(): void {
            this.advisorService.getAdvisorAvailableMeetingTimes().then(resp => {
                this.availableMeetingTimes = resp.data.concat();
                // Adjust dates to match the timezone
                var localOffset = (new Date()).getTimezoneOffset();
                this.availableMeetingTimes.forEach(av => {
                    av.days.forEach(d => {
                        var date = new Date(d.date)
                        d.date = new Date(date.setTime(date.getTime() + localOffset * 60 * 1000));
                    })
                })
                console.log(resp);
            }).catch(err => {
                console.log(err);
            })
        }


        $onInit(): void {
            this.getAvailableMeetingTimes();
        }

        $onChanges(evt) {
            console.log(evt);
        }
    }

    class MeetingCrud implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                meeting: "<",
                meetingDate: "<",
                isAdvisor: "<",
                onScheduleMeetingLater: "&",
                onCreateMeeting: "&",
                onUpdateMeeting: "&",
                onCancel: "&"
            };
            this.controller = [`meetingHubService`, `advisorService`,MeetingCrudController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/views/meeting-crud.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingCrud`, new MeetingCrud());

}